import * as React from 'react';
import { QuestionnaireEvaluationQuestionType } from "../../questionnaireEvaluation";
import { PhotoCaptureConstants } from '../constants';
import { attachedArtifactIdsToUpdate, isArtifactIdExist } from '../utilities';
export const usePhotoCaptureVinWorker = ({ isSaveSuccess, companyCode, evaluationDocId, questionnaireId, questionnaireQuestionId, contextId, isContextUpdated, isTermsAndConditionAccepted, photoCaptureAttachmentInfo, parentQuestionId, attachedArtifactIds, photoCaptureUpdateContextDataAction, questionnaireEvaluationQuestionGetAction, questionnaireEvaluationSaveRequestAction, photoCaptureResetContextAction, photoCaptureUpdateAttachedArtifactIdSuccessAction }) => {
    const [answerValue, setAnswerValue] = React.useState('');
    const changeQuestion = (evaluationDocId, questionnaireId, questionnaireQuestionId, questionType) => {
        photoCaptureResetContextAction();
        const questionGetParams = {
            companyCode,
            evaluationDocId: parseInt(evaluationDocId),
            questionnaireId: parseInt(questionnaireId),
            questionnaireQuestionId,
            questionType
        };
        questionnaireEvaluationQuestionGetAction(questionGetParams);
    };
    React.useEffect(() => {
        isSaveSuccess &&
            evaluationDocId &&
            questionnaireId &&
            questionnaireQuestionId &&
            changeQuestion(evaluationDocId, questionnaireId, questionnaireQuestionId, QuestionnaireEvaluationQuestionType.NEXT);
    }, [isSaveSuccess]);
    React.useEffect(() => {
        if (evaluationDocId && questionnaireQuestionId && isContextUpdated) {
            const saveQuestionParams = {
                isCacheOnly: false,
                evalId: evaluationDocId,
                coCode: companyCode,
                shouldIncludeEvalution: false,
                questionsData: [
                    {
                        qustnnrQustnId: questionnaireQuestionId,
                        answer: answerValue
                    }
                ]
            };
            questionnaireEvaluationSaveRequestAction(saveQuestionParams);
        }
    }, [isContextUpdated]);
    const updateContextParams = {
        attachmentInfo: photoCaptureAttachmentInfo,
        documentId: evaluationDocId,
        fraudWarningAccept: PhotoCaptureConstants.ZERO_STRING,
        isTermsAndConditionAccepted: isTermsAndConditionAccepted ? PhotoCaptureConstants.Y : PhotoCaptureConstants.N,
        status: null,
        vehicle: null
    };
    const updateContext = (contextDataUpdateInput = updateContextParams) => {
        photoCaptureUpdateContextDataAction(contextDataUpdateInput, contextId, companyCode);
    };
    const moveNext = (value) => {
        setAnswerValue(value);
        updateContext();
    };
    const movePrevious = () => {
        const attachedArtifactId = {
            parentQuestionId,
            questionnaireQuestionId
        };
        if (!isArtifactIdExist(attachedArtifactIds, attachedArtifactId)) {
            questionnaireQuestionId &&
                photoCaptureUpdateAttachedArtifactIdSuccessAction(attachedArtifactIdsToUpdate(attachedArtifactIds, attachedArtifactId));
        }
        evaluationDocId &&
            questionnaireId &&
            questionnaireQuestionId &&
            changeQuestion(evaluationDocId, questionnaireId, questionnaireQuestionId, QuestionnaireEvaluationQuestionType.PREVIOUS);
    };
    return { moveNext, movePrevious };
};
//# sourceMappingURL=usePhotoCaptureVinWorker.js.map